import { isEqual } from 'lodash-es';
import type { ReactNode } from 'react';
import { useLayoutEffect, useMemo, useRef, useState } from 'react';
import type { ControllerRenderProps, FieldErrors } from 'react-hook-form';

// both are used in current project
// export DefaultRequiredStringIndicator = ' *'
export const DefaultRequiredStringIndicator = '*';

// Note: naming without "error", maybe not only for error in the future
export const getFieldTooltip = (error?: FieldErrors[string]) => {
  if (!error) return undefined;
  return {
    Tooltip: { Message: error.message },
  };
};
export const useStableValue = <T = any,>(value: T): T => {
  const valueRef = useRef(value);
  return useMemo(() => {
    const isEq = isEqual(value, valueRef.current);
    if (!isEq) valueRef.current = value;
    return valueRef.current;
  }, [value]);
};
export const useStablePlaceholder = (): [React.RefObject<HTMLElement>, ReactNode] => {
  const domRef = useRef<HTMLElement>(null);
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => {
    setHeight(domRef.current?.clientHeight || 0);
  }, []);
  const stablePlaceholder = useMemo(() => {
    return <div style={{ height }} />;
  }, [height]);
  return [domRef, stablePlaceholder];
};

function handleFieldUp(
  field: ControllerRenderProps,
  options?: { disabledRef: boolean; defaultValue?: any },
) {
  const { disabledRef, defaultValue } = options || {};

  return {
    Name: field.name,
    Value: field.value ?? defaultValue ?? '',
    OnChange: (newValue) => {
      field.onChange(newValue);
    },
    OnBlur: (newValue) => {
      field.onBlur(newValue);
    },
    Disabled: field.disabled,
    ref: disabledRef ? undefined : field.ref,
  };
}

function handleField(field: ControllerRenderProps, options?: { disabledRef: boolean }) {
  const { disabledRef } = options || {};

  return {
    name: field.name,
    value: field.value,
    onChange: (newValue) => {
      field.onChange(newValue);
    },
    onBlur: () => {
      field.onBlur();
    },
    disabled: field.disabled,
    ref: disabledRef ? undefined : field.ref,
  };
}

export { handleField, handleFieldUp };
